import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const STORAGE_KEY = "dashboard.workspace";
const WORKSPACES = ["ops", "analytics"];

function readStored() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    if (WORKSPACES.includes(v)) return v;
  } catch (e) {
    /* ignore */
  }
  return null;
}

function workspaceFromPath(pathname) {
  if (pathname.startsWith("/admin/analytics")) return "analytics";
  if (pathname.startsWith("/admin/operations")) return "ops";
  return null;
}

export default function useWorkspace(defaultWorkspace = "ops") {
  const location = useLocation();
  const navigate = useNavigate();
  const [workspace, setWorkspace] = useState(
    () => workspaceFromPath(location.pathname) || readStored() || defaultWorkspace
  );

  useEffect(() => {
    const fromPath = workspaceFromPath(location.pathname);
    if (fromPath && fromPath !== workspace) setWorkspace(fromPath);
  }, [location.pathname, workspace]);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, workspace);
    } catch (e) {
      /* ignore */
    }
  }, [workspace]);

  const switchTo = useCallback(
    (next) => {
      if (!WORKSPACES.includes(next)) return;
      setWorkspace(next);
      const target = next === "analytics" ? "/admin/analytics" : "/admin/operations";
      navigate(target);
    },
    [navigate]
  );

  return { workspace, switchTo, workspaces: WORKSPACES };
}
